// extracted by mini-css-extract-plugin
export default {"component":"oY_GN5","withIcon":"kVABff","input":"cDi2IQ","fail":"tPFW9n","big":"UFkO8r"};